import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { LoadingMaskService } from '../../../shared/loading-mask/loading-mask.service';
import { AvailAlerts, AvailAlertsService } from './avail-alerts.service';
import { CommonFiltersResolve } from '../filters/common-filters-resolve';
import { ActiveFiltersService } from '../filters/active-filters.service';

@Injectable()
export class AvailAlertsResolve extends CommonFiltersResolve implements Resolve<AvailAlerts[]> {
	constructor(private service: AvailAlertsService,
	            private activeFiltersService: ActiveFiltersService,
	            private mask: LoadingMaskService) {
		super(activeFiltersService);
	}

	resolve(route: ActivatedRouteSnapshot): Promise<AvailAlerts[]> {
		this.mask.addLoading();
		let filters: any = this.initActiveFiltersFromURLParams(route);
		return this.service.getAvailAlerts(filters)
			.then((availAlerts: AvailAlerts[]) => {
				this.mask.removeLoading();
				return availAlerts;
			});
	}
}
